export default "__VITE_ASSET__B3emC_V6__"